export default __webpack_public_path__ + "static/media/imgs7.7bd3649e.webp";